import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {GeneralHttpHelperService} from '../../helpers/general-http-helper.service';
import {InsightsDetailsTypeEnums} from '../../../enums/profile-enums';

const SETTINGS_API_ROUTES = {
  DELETE_ACCOUNT: 'user/profile',
  GET_INSIGHTS_OVERVIEW: 'insights/overview',
  GET_INSIGHTS_LISTS: 'insights/get_lysts_for_period',
  GET_INSIGHTS_FOLLOWER: 'insights/details/followers',
  GET_INSIGHTS_DETAILS_FOLLOWERS: 'insights/details/followers',
  GET_INSIGHTS_DETAILS_LIKES: 'insights/details/lyst_likes',
  GET_INSIGHTS_DETAILS_VIEWS: 'insights/details/lyst_views',
  GET_INSIGHTS_DETAILS_SHARES: 'insights/details/lyst_shares',
  GET_INSIGHTS_DETAILS_LIST_OVERVIEW: 'insights/details/lysts/:listId/overview',
  GET_INSIGHTS_DETAILS_LIST_LIKES: 'insights/details/lysts/:listId/likes',
  GET_INSIGHTS_DETAILS_LIST_VIEWS: 'insights/details/lysts/:listId/views',
  GET_INSIGHTS_DETAILS_LIST_SHARES: 'insights/details/lysts/:listId/shares'
};

@Injectable({
  providedIn: 'root'
})
export class SettingsHttpService {

  constructor(private httpClient: HttpClient,
              private generalHttpHelperService: GeneralHttpHelperService) {

  }

  private deleteAccountReq(bodyParams: any): Observable<any> {
    return this.httpClient.post(SETTINGS_API_ROUTES.DELETE_ACCOUNT, bodyParams) as any;
  }

  deleteAccount(bodyParams: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.deleteAccountReq(bodyParams).subscribe((res: any) => {
        resolve(res);
      }, error => {
        reject(error);
      });
    });
  }

  private getInsightsOverviewReq(urlParams: any): Observable<any> {
    const apiUrl = this.generalHttpHelperService.addUrlParams(SETTINGS_API_ROUTES.GET_INSIGHTS_OVERVIEW, urlParams);
    return this.httpClient.get(apiUrl) as any;
  }

  getInsightsOverview(urlParams: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.getInsightsOverviewReq(urlParams).subscribe((res: any) => {
        resolve(res);
      }, error => {
        reject(error);
      });
    });
  }

  private getInsightsListsReq(urlParams: any): Observable<any> {
    const apiUrl = this.generalHttpHelperService.addUrlParams(SETTINGS_API_ROUTES.GET_INSIGHTS_LISTS, urlParams);
    return this.httpClient.get(apiUrl) as any;
  }

  getInsightsLists(urlParams: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.getInsightsListsReq(urlParams).subscribe((res: any) => {
        resolve({
          data: res.data.data,
          pagination: this.generalHttpHelperService.returnPagination(res.data)
        });
      }, error => {
        reject(error);
      });
    });
  }

  private getInsightsListOverviewReq(urlParams: any): Observable<any> {
    const {listId, ...restUrlParams} = urlParams;
    let apiUrl = this.generalHttpHelperService.replaceUrlParamsWithValues(SETTINGS_API_ROUTES.GET_INSIGHTS_DETAILS_LIST_OVERVIEW, {listId});
    apiUrl = this.generalHttpHelperService.addUrlParams(apiUrl, restUrlParams);
    return this.httpClient.get(apiUrl) as any;
  }

  getInsightsListOverview(urlParams: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.getInsightsListOverviewReq(urlParams).subscribe((res: any) => {
        resolve(res);
      }, error => {
        reject(error);
      });
    });
  }

  private getInsightsDetailsReq(urlParams: any, type: string): Observable<any> {
    let url = '';
    switch (type) {
      case InsightsDetailsTypeEnums.followers:
        url = SETTINGS_API_ROUTES.GET_INSIGHTS_DETAILS_FOLLOWERS;
        break;
      case InsightsDetailsTypeEnums.likes:
        url = SETTINGS_API_ROUTES.GET_INSIGHTS_DETAILS_LIKES;
        break;
      case InsightsDetailsTypeEnums.views:
        url = SETTINGS_API_ROUTES.GET_INSIGHTS_DETAILS_VIEWS;
        break;
      case InsightsDetailsTypeEnums.shares:
        url = SETTINGS_API_ROUTES.GET_INSIGHTS_DETAILS_SHARES;
    }
    const apiUrl = this.generalHttpHelperService.addUrlParams(url, urlParams);
    return this.httpClient.get(apiUrl) as any;
  }

  getInsightsDetails(urlParams: any, type: string): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.getInsightsDetailsReq(urlParams, type).subscribe((res: any) => {
        resolve(res);
      }, error => {
        reject(error);
      });
    });
  }

  private getInsightsSingleListDetailsReq(urlParams: any, type: string): Observable<any> {
    const {listId, ...restUrlParams} = urlParams;
    let url = '';
    switch (type) {
      case InsightsDetailsTypeEnums.likes:
        url = this.generalHttpHelperService.replaceUrlParamsWithValues(SETTINGS_API_ROUTES.GET_INSIGHTS_DETAILS_LIST_LIKES, {listId});
        break;
      case InsightsDetailsTypeEnums.views:
        url = this.generalHttpHelperService.replaceUrlParamsWithValues(SETTINGS_API_ROUTES.GET_INSIGHTS_DETAILS_LIST_VIEWS, {listId});
        break;
      case InsightsDetailsTypeEnums.shares:
        url = this.generalHttpHelperService.replaceUrlParamsWithValues(SETTINGS_API_ROUTES.GET_INSIGHTS_DETAILS_LIST_SHARES, {listId});
    }
    const apiUrl = this.generalHttpHelperService.addUrlParams(url, restUrlParams);
    return this.httpClient.get(apiUrl) as any;
  }

  getInsightsSingleListDetails(urlParams: any, type: string): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.getInsightsSingleListDetailsReq(urlParams, type).subscribe((res: any) => {
        resolve(res);
      }, error => {
        reject(error);
      });
    });
  }
}
